import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'partner-solutions',
  footer: 'partner-solutions',
}

const pageBrand: PageBrand = 'corporate'

export const partnerSolutions = new LineOfBusinessConfig(geConfig, pageBrand)
